"use client";

import { NotFound } from "@caffeina-siad/ui-kit/src/components/organisms";
import BaseLayout from "@/layouts/BaseLayout";

export default function NotFoundPage() {
  return (
    <BaseLayout>
      <NotFound />
    </BaseLayout>
  );
}
